import { arrayContainAll } from '@/utils/math';
import { EVENT_FORMAT } from '@/utils/constants';

export function isParticipatingToAllHybridFormats (keyMomentFormats) {
  return arrayContainAll(keyMomentFormats, [EVENT_FORMAT.PHYSICAL, EVENT_FORMAT.VIRTUAL])
}